export const getGenderCartContents = (orderItem) => {
    const itemsWithGender = orderItem.map((item) => item.catalogEntryView.attributes.filter((att) => att.identifier === 'Gender')).flat()
    const mappedItems = itemsWithGender && itemsWithGender.map((item) => item.values[0].identifier)
    return mappedItems
        ? mappedItems.includes('Woman') && mappedItems.includes('Man')
            ? 'Unspecified'
            : mappedItems[0] === 'Woman'
            ? 'Female'
            : 'Male'
        : undefined
}
